import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

export default class extends Controller {
    static values = {
        labels: Array,
        data: Array,
        weights: Array, // Optional: if we want to visually represent weight differently
        colors: Array
    }

    connect() {
        // Check if canvas exists, if not created by partial, we create it
        let canvas = this.element.querySelector('canvas')
        if (!canvas) {
            canvas = document.createElement('canvas')
            this.element.appendChild(canvas)
        }
        const ctx = canvas.getContext('2d')

        const data = {
            labels: this.labelsValue,
            datasets: [{
                label: 'Risk Distribution',
                data: this.weightsValue || this.dataValue, // Distribution usually uses weights for size
                backgroundColor: this.colorsValue || [
                    '#4f46e5', // Primary
                    '#10b981', // Success
                    '#f59e0b', // Warning
                    '#ef4444'  // Error
                ],
                borderWidth: 0,
                hoverOffset: 15
            }]
        }

        const config = {
            type: 'polarArea', // Polar Area is great for "Weighted Risk Progress" / distribution
            data: data,
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: false // Custom legend usually looks better
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                const label = context.label || '';
                                const value = context.raw; // This is the weight/size
                                // If we had the actual 'score' values separate from 'weight', we would need to map them back.
                                // For now assumes the visualization inputs match the desired display value.
                                return `${label}: ${value}%`;
                            }
                        }
                    }
                },
                scales: {
                    r: {
                        grid: {
                            display: false,
                        },
                        ticks: {
                            display: false
                        },
                        suggestedMin: 0
                    }
                }
            }
        }

        this.chart = new Chart(ctx, config)
    }

    disconnect() {
        if (this.chart) {
            this.chart.destroy()
        }
    }
}
